import {ROUTES} from '@/config/constants'
import {useAuth} from '@/hooks/useAuth'
import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

export const Login = () => {
  const {handleLogin, isAuthenticated} = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.HOME)
      return
    }

    handleLogin('redirect')
  }, [isAuthenticated, navigate, handleLogin])

  return null
}
